import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../../';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { ThirdPartyBillingAccount } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface ThirdPartyBillingAccountsModel {
  thirdPartyBillingAccountsMap: Record<string, ThirdPartyBillingAccount>;
  setThirdPartyBillingAccounts: Action<ThirdPartyBillingAccountsModel, ThirdPartyBillingAccount[]>;
  setThirdPartyBillingAccount: Action<ThirdPartyBillingAccountsModel, ThirdPartyBillingAccount>;
  fetchThirdPartyBillingAccountsLoading: boolean;
  setFetchThirdPartyBillingAccountsLoading: Action<ThirdPartyBillingAccountsModel, boolean>;
  fetchThirdPartyBillingAccounts: Thunk<ThirdPartyBillingAccountsModel, void, Injections, StoreModel, Promise<void>>;
  fetchThirdPartyBillingAccountsFailure: Action<ThirdPartyBillingAccountsModel, ApplicationErrorOptions>;
}

export const thirdPartyBillingAccountsModel: ThirdPartyBillingAccountsModel = {
  thirdPartyBillingAccountsMap: {},
  setThirdPartyBillingAccounts: action((state, thirdPartyBillingAccounts) => {
    const thirdPartyBillingAccountsMap = thirdPartyBillingAccounts.reduce<Record<string, ThirdPartyBillingAccount>>(
      (acc, curr) => {
        acc[curr.thirdPartyBillingAccountId] = curr;
        return acc;
      },
      {},
    );
    state.thirdPartyBillingAccountsMap = thirdPartyBillingAccountsMap;
  }),
  setThirdPartyBillingAccount: action((state, thirdPartyBillingAccount) => {
    state.thirdPartyBillingAccountsMap[thirdPartyBillingAccount.thirdPartyBillingAccountId] = thirdPartyBillingAccount;
  }),
  fetchThirdPartyBillingAccountsLoading: false,
  setFetchThirdPartyBillingAccountsLoading: action((state, isLoading) => {
    state.fetchThirdPartyBillingAccountsLoading = isLoading;
  }),
  fetchThirdPartyBillingAccounts: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchThirdPartyBillingAccountsLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchThirdPartyBillingAccounts();
      actions.setThirdPartyBillingAccounts(response);
      actions.setFetchThirdPartyBillingAccountsLoading(false);
      return response;
    } catch (error) {
      actions.fetchThirdPartyBillingAccountsFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchThirdPartyBillingAccountsLoading(false);
      return error;
    }
  }),
  fetchThirdPartyBillingAccountsFailure: action((state, error) => {
    console.error(error);
  }),
};

export default thirdPartyBillingAccountsModel;
